import type { IModelConnection } from "@itwin/core-frontend";
import { QueryBinder, QueryRowFormat } from "@itwin/core-common";
import { ConstructionPhase } from "../../../domain/contracts/ConstructionPhase";
import { DOTPayItemIndex } from "./dotPayItemQuery";

const DOTPAYITEM_SCHEMA =
  "DgnCustomItemTypes_DOT_DigitalAssetMetadata";

/**
 * Build the ECSQL to read ConstructionPhase info
 * for a given DOT_PayItem{index} aspect.
 */
function buildConstructionPhaseByElementQuery(
  index: DOTPayItemIndex,
): string {
  if (index < 1 || index > 5) {
    throw new Error(`Invalid DOT_PayItem index: ${index}`);
  }

  return `
    SELECT
      p.ConstructionPhase.YR           AS YR,
      p.ConstructionPhase.Stage        AS Stage,
      p.ConstructionPhase.Class        AS Class,
      p.ConstructionPhase.[Group]      AS [Group],
      p.ConstructionPhase.Sequence     AS Sequence,
      p.ConstructionPhase.ActivityName AS ActivityName
    FROM ${DOTPAYITEM_SCHEMA}.DOT_PayItem${index}ElementAspect p
    WHERE p.Element.Id = ?
  `;
}

export async function queryConstructionPhaseForElement(
  iModel: IModelConnection,
  elementId: string,
  index: DOTPayItemIndex,
): Promise<ConstructionPhase | undefined> {
  const bindings = QueryBinder.from([elementId]);

  const reader = iModel.createQueryReader(
    buildConstructionPhaseByElementQuery(index),
    bindings,
    { rowFormat: QueryRowFormat.UseECSqlPropertyNames }
  );

  for await (const row of reader) {
    const plain = row.toRow() as any;   // { YR, Stage, Class, Group, Sequence, ActivityName }
    return ConstructionPhase.fromObject(plain);
  }

  // No ConstructionPhase info for that element/index
  return undefined;
}
